import { UAParser } from 'ua-parser-js'

export const isMobileDevice = (userAgent: string | undefined) => {
  if (!userAgent) return false
  const parser = new UAParser(userAgent)
  return parser.getDevice().type === 'mobile'
}
